import { styled, keyframes } from 'styled-components';
export const fadeInKeyframes = keyframes `
from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
`;
export const FadeInAnimation = styled.div `
  animation: ${fadeInKeyframes} ${props => props.$duration || 0.5}s ease-in;
`;
//# sourceMappingURL=Animations.js.map